module.exports = __webpack_public_path__ + "img/Slice 268@2x(4).beb13176.png";